import { Loader2Icon } from "lucide-react";

import { cn } from "@lib/utils";

export const Spinner = ({ className, ...props }: React.ComponentProps<"svg">) => (
	<Loader2Icon
		role="status"
		aria-label="Loading"
		color={props.color || "var(--color-primary)"}
		className={cn("size-4 animate-spin", className)}
		{...props}
	/>
);

Spinner.displayName = "Spinner";
